(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("intraactive-sdk-helper"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "intraactive-sdk-helper", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("react"), require("intraactive-sdk-helper"), require("react-dom"));
	else
		root["index"] = factory(root["react"], root["intraactive-sdk-helper"], root["react-dom"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__36__) {
return 